import { Injectable } from '@angular/core';
import { BcRestApi } from '../api/rest-api';
import { IntegrationModel } from './integration.model';
import { WorkItemTypes } from '../workitems/constants/workitem-types';

@Injectable()
export class IntegrationsService {
  constructor(private bcRestApi: BcRestApi) {
  }

  getIntegrations(chatId: string, type: string): Promise<IntegrationModel[]> {
    // Email integrations are not yet supported
    if (type === WorkItemTypes.EMAIL || type === WorkItemTypes.COMPOSE_EMAIL) {
      return Promise.resolve([]);
    }
    return this.bcRestApi.getIntegrations(chatId, type);
  }

  getIntegrationUrl(chatId: string, integrationId: string, type: string): Promise<string> {
    return this.bcRestApi.getIntegrationUrl(chatId, integrationId, type)
      .then((responseBody) => {
        return <string> responseBody.url;
      });
  }
}
